import { z } from 'zod'
import type { Hex } from '../../types'
import type { Contract } from '../types'
import type { KaiascanClient } from './client'

type GetContractSourceCodeForAVerifiedContractParameters = {
  client: KaiascanClient
  address: Hex
  headers?: Record<string, string>
}

const resultSchema = z.array(
  z.object({
    ABI: z.string().optional(),
    ContractName: z.string().optional(),
  }),
)

/**
 * Kaiascan から verified contract の ABI と名前を取得する。
 *
 * @param parameters - client、contract address、headers。
 * @returns contract 情報。未 verify または ABI 不正時は undefined。
 */
export const getContractSourceCodeForAVerifiedContract = async ({
  client,
  address,
  headers,
}: GetContractSourceCodeForAVerifiedContractParameters): Promise<
  Contract | undefined
> => {
  const result = await client.get({
    path: '',
    query: {
      module: 'contract',
      action: 'getsourcecode',
      address,
    },
    resultSchema,
    headers,
  })
  const contract = result[0]
  if (contract === undefined) {
    return undefined
  }
  if (
    contract.ABI === undefined ||
    contract.ABI.length === 0 ||
    contract.ABI === 'Contract source code not verified' ||
    contract.ContractName === undefined ||
    contract.ContractName.length === 0
  ) {
    return undefined
  }
  try {
    JSON.parse(contract.ABI)
  } catch {
    return undefined
  }
  return {
    abi: contract.ABI,
    name: contract.ContractName,
  }
}
